export var source = "fragment ProductDetailed on Product {\n  ...ProductBase\n  ...ProductNotes\n  reviewsCount\n  description\n}";
import { source as fragment1 } from "./productBase.graphql";
import { source as fragment2 } from "./productNotes.graphql";
var combined = source  + "\n" + fragment1 + "\n" + fragment2;
export default combined;